const n = (t) => 1 / t === 1 / 0 || 1 / t === -1 / 0, r = (t) => Array.isArray(t) ? t.length : t instanceof Map || t instanceof Set ? t.size : t instanceof RegExp ? t.source.length : Object.keys(t).length, e = (t) => t == null || !t || typeof t == "number" && (n(t) || Number.isNaN(t)) || typeof t == "object" && r(t) === 0;
export {
  e as isEmpty
};
